import { Row, Text } from "@/components";

import { dates } from "@/lib/dates";

export const DateDivider = ({ date }: { date: string }) => {
  /* Render */
  const render = () => (
    <Row className="items-center justify-center">
      <Text className="text-xs font-medium text-slate-400">
        {dates.formatDateDivider(date)}
      </Text>
    </Row>
  );

  return render();
};
